import * as React from 'react';
import Svg, { G, Path } from 'react-native-svg';
import {GlobalVariables} from '../../utils/globalVariables';
const IconDownload = (props:any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <G fill={props.fill ? props.fill : GlobalVariables.colors.secondary.white}>
      <Path d="M9.577 17.989a1.314 1.314 0 0 0 1.858 0l6.563-6.563a1.314 1.314 0 1 0-1.858-1.858L11.816 13.9V1.313a1.313 1.313 0 0 0-2.625 0v12.579L4.868 9.573a1.314 1.314 0 1 0-1.858 1.858l6.563 6.562Z" />
      <Path d="M0 19.688a1.311 1.311 0 0 1 1.313-1.313h18.375a1.313 1.313 0 0 1 0 2.625H1.313A1.311 1.311 0 0 1 0 19.688Z" />
    </G>
  </Svg>
);
export default IconDownload;
